import { render, staticRenderFns } from "./AlertGlobal.vue?vue&type=template&id=0e6cf03e&scoped=true&"
import script from "./AlertGlobal.vue?vue&type=script&lang=js&"
export * from "./AlertGlobal.vue?vue&type=script&lang=js&"
import style0 from "./AlertGlobal.vue?vue&type=style&index=0&id=0e6cf03e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6cf03e",
  null
  
)

export default component.exports